import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import DowLogo from '@src/assets/pbdj.png';

import AlertHit from './AlertHit';

const Container = styled.div`
  padding: 32px 16px 12px 16px;
  border-top: ${props => props.theme.borderMd};
`;

const LogoContainer = styled.img`
  height: 20px;
  float: right;
`

function HitList({ hits, alertId }) {
  const clearedHits = hits.filter(item => item.decision === 0);
  const escalatedHits = hits.filter(item => item.decision === 1);

  const hasCleared = clearedHits.length > 0;
  const hasEscalated = escalatedHits.length > 0;
  const djwLogo = <LogoContainer src={DowLogo} height={20} />

  return (
    <div>
      {hasEscalated && (
        <Container>
          <b>{escalatedHits.length} hits escalated</b> 
        {djwLogo}
        </Container>
      )}
      {hasEscalated &&
        escalatedHits.map((item, index) => {
          return <AlertHit {...item} index={index} alertId={alertId} />;
        })}
      {hasCleared && (
        <Container>
          <b>{clearedHits.length} hits cleared</b>
        </Container>
      )}
      {hasCleared &&
        clearedHits.map((item, index) => {
          return (
            <AlertHit
              {...item}
              index={escalatedHits.length + index}
              alertId={alertId}
            />
          );
        })}
    </div>
  );
}

HitList.propTypes = {
  hits: PropTypes.array,
  alertId: PropTypes.string.isRequired,
};

HitList.defaultProps = {
  hits: [],
};

HitList.displayName = 'HitList';

export default HitList;
